// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3topA","tab":"ProcedureTabs_tab__nYJg_"};